module.exports = __webpack_public_path__ + "img/1-1.f5502c61.png";